export function categoryColors(name = '') {
  let hash = 0;
  for (const char of name.trim().toLocaleLowerCase('pt-BR')) hash = (Math.imul(hash, 31) + char.codePointAt(0)) | 0;
  const hue = (hash >>> 0) % 360;
  return {
    '--reservation-bg': `hsl(${hue}, 75%, 94%)`,
    '--reservation-text': `hsl(${hue}, 65%, 22%)`,
    '--reservation-accent': `hsl(${hue}, 70%, 42%)`,
    '--reservation-dark-bg': `hsl(${hue}, 38%, 20%)`,
    '--reservation-dark-text': `hsl(${hue}, 80%, 94%)`,
    '--reservation-dark-accent': `hsl(${hue}, 80%, 70%)`,
  };
}
